const handleFlyoutSwitch = ($mainTree, $subTree, $link, event) => {
    const targetId = $link.getAttribute('data-navigation-sub-tree-target');
    if (!targetId) {
        return;
    }

    event.preventDefault();

    const $subTreeCategories = $subTree.querySelectorAll('[data-navigation-sub-tree-id]');

    Array.prototype.forEach.call($subTreeCategories, ($subTreeCategory) => {
        const subTreeId = $subTreeCategory.getAttribute('data-navigation-sub-tree-id');

        if (subTreeId === targetId) {
            $subTreeCategory.classList.add('is-active');
        } else {
            $subTreeCategory.classList.remove('is-active');
        }
    });

    $mainTree.classList.add('is-hidden');
    $subTree.classList.remove('is-hidden');
};

const handleFlyoutBack = ($mainTree, $subTree, event) => {
    $mainTree.classList.remove('is-hidden');
    $subTree.classList.add('is-hidden');
};

const initialize = ($flyout) => {
    const menuId = $flyout.getAttribute('data-flyout-menu-id');
    if (!menuId) {
        return;
    }

    const $mainTree = $flyout.querySelector('.js-main-tree');
    const $subTree = $flyout.querySelector('.js-sub-tree');
    const $navLinks = $mainTree.querySelectorAll('.js-nav-link');
    const $backButtons = $subTree.querySelectorAll('.js-back-button');

    Array.prototype.forEach.call($navLinks, ($navLink) => {
        $navLink.addEventListener('click', handleFlyoutSwitch.bind(
            undefined,
            $mainTree,
            $subTree,
            $navLink,
        ));
    });

    Array.prototype.forEach.call($backButtons, ($backButton) => {
        $backButton.addEventListener('click', handleFlyoutBack.bind(
            undefined,
            $mainTree,
            $subTree,
        ));
    });
};

(() => {
    const $flyouts = document.querySelectorAll('.navigation-flyout');
    Array.prototype.forEach.call($flyouts, initialize);
})();
